























































import UserRequired from "@/components/UserRequired";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import {DateTime, InvoicingExceptedLocation, TerminalLocation} from "@/modules/models";
import Api from "@/components/location/Api";
import BaseApi from "@/store/modules/base";
import MonthChoice from "@/modules/MonthChoice";
import LicenseTypePara from "@/components/terminals/LicenseTypePara.vue";
import rd from "@/modules/vRoutedefs";

@Component({
    components: {
        "at-license-type-para": LicenseTypePara,
    }
})
export default class InvoicingInfo extends UserRequired {
    @Inject()
    api!: Api;
    @Inject()
    baseApi!: BaseApi;

    @Prop({default: null})
    location!: TerminalLocation | null;

    showDlg = false;

    invoicingExcepted: InvoicingExceptedLocation[] = [];

    get currentInvoiceException() {
        const now = DateTime.now();
        const filtered = this.invoicingExcepted.filter((r) => r.fromTs.isBefore(now) && r.toTs.isAfter(now));
        if(filtered.length > 0) {
            return filtered[0];
        }
        return null;
    }

    get summaryTxt() {
        if(this.location) {
            if (this.location.isShutdown) {
                return `Avsluttet - faktureres ikke`;
            } else {
                const excepted = this.currentInvoiceException;
                if(excepted) {
                    return `Fritatt til ${excepted.toTs.toLocalDate()}`;
                }
                return `Faktureres som vanlig`
            }
        }
        return ``;
    }

    invoicingExceptedHeaders = [
        {text: "Fra", value: "fromTs"},
        {text: "Til", value: "toTs"},
        {text: "Årsak", value: "reason"},
        {text: "", value: "", sortable: false}
    ];
    get invoiceExceptFromChoices(): MonthChoice[] {
        let ret: MonthChoice[] = [];
        for(let i = -8; i <= 2; i++) {
            ret.push(new MonthChoice(DateTime.now().monthOffset(i)));
        }
        return ret;
    }
    get invoiceExceptToChoices(): MonthChoice[] {
        let ret: MonthChoice[] = [];
        for(let i = -4; i <= 13; i++) {
            ret.push(new MonthChoice(DateTime.now().monthOffset(i)));
        }
        return ret;
    }
    get invoiceExceptReasons(): string[] {
        return [ "Avtalt prøveperiode", "Godvilje", "Forhåndsfakturert" ];
    }
    invoiceExceptFrom: DateTime | null = null;
    invoiceExceptTo: DateTime | null = null;
    invoiceExceptReason: string | null = null;
    async invoiceExceptAdd() {
        if(this.location && this.invoiceExceptFrom && this.invoiceExceptTo && this.invoiceExceptReason) {
            await this.api.addInvoicingExceptedLocation(this.location.id, this.invoiceExceptFrom, this.invoiceExceptTo, this.invoiceExceptReason);
            this.invoicingExcepted = await this.api.fetchInvoicingExceptedLocations(this.location.id);
            this.invoiceExceptFrom = null;
            this.invoiceExceptTo = null;
            this.invoiceExceptReason = null;
        }
    }
    async invoicingExceptedDelete(id: number) {
        await this.api.delInvoicingExceptedLocation(id);
        if(this.location != null) {
            this.invoicingExcepted = await this.api.fetchInvoicingExceptedLocations(this.location.id);
        }
    }

    @Watch("location", {immediate: true})
    async onLocationChanged() {
        if(this.location) {
            this.invoicingExcepted = await this.api.fetchInvoicingExceptedLocations(this.location.id);
        }
    }

    get isSuper() {
        return this.location != null && this.user.isCompanySuper(this.location.companyOrgNum);
    }

    get systemBillingOverviewTo() {
        return {name: rd.system.billing.name};
    }
}
